import Swal from "sweetalert2";

const warningMessages = {
  0: "Please select date and device",
  1: "There is no data matching the conditions",
  2: "This device is already registered",
  3: "This category is already registered.",
  4: "Default category cannot be deleted",
  5: "User is already registered",
  6: "Error, contact the administrator",
};

/* const warningMessages = {
  0: "날짜 및 디바이스를 선택해주세요",
  1: "조건에 맞는 데이터가 없습니다.",
  2: "이미 등록된 장치입니다.",
  3: "이미 등록된 카테고리입니다.",
  4: "기본 카테고리는 지울 수 없습니다.",
  5: "이미 등록된 유저입니다.",
  6: "에러 발생, 관리자에게 문의하세요.",
}; */

export default function WarningAlert(text) {
  Swal.fire({
    icon: "error",
    text: text,
    toast: true,
    position: "center",
    showConfirmButton: true,
    timer: 2000,
    timerProgressBar: true,
    confirmButtonText: "Confirm",
  });
}
